import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { changeFormField } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { Row } from 'apps/auth/components/common/Layout/Row';
import NewInputWrapper from 'apps/auth/components/form-multi/NewInputWrapper';
import { getCaptchaURL, validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { REQ_ERROR } from 'apps/auth/constants/Constants';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { usePageMessages, useJsMessages } from 'apps/auth/hooks/selectors';

import media from '../../theme/media';

const CaptchaContainer = styled.div`
    margin: -15px 16px -15px -15px;
    min-width: 50%;
    border-radius: 6px 0 0 6px;
    text-align: center;
    overflow: hidden;

    img {
        max-width: 100%;
        height: 56px;
    }

    ${media.desktop1920} {
        margin: -19px 24px -19px -24px;

        img {
            height: 69px;
        }
    }
`;

const InputCaptcha = (props) => {
    const [isFilled, setIsFilled] = useState(!!props.field.value || props.focus);
    const [captchaUrl, setCaptchaUrl] = useState(props.captchaUrl ? props.captchaUrl : getCaptchaURL());
    const [isEmptyValue, setEmptyValue] = useState(!props.field.value);
    const [isFocused, setFocused] = useState(false);
    const { restorePassChangeCaptcha } = usePageMessages();
    const jsMessages = useJsMessages();
    const { field = {} } = props;

    useEffect(() => {
        setIsFilled(!!props.field.value);
    }, [props.field.value]);
    useEffect(() => {
        setCaptchaUrl(props.captchaURL);
    }, [props.captchaURL]);

    const handlerBlur = (e) => {
        setIsFilled(!!e.target.value);
        setEmptyValue(!e.target.value);
        setFocused(false);
        validationAndUpdateValue(props.formName, e.target.value, props.field, props.changeFormField);
    };

    const handlerChange = (e) => {
        validationAndUpdateValue(props.formName, e.target.value, props.field, props.changeFormField);
    };

    const handlerFocus = () => {
        setIsFilled(true);
        setFocused(true);
    };
    const focus = (e) => {
        if (e.currentTarget) {
            const input = e.currentTarget.firstElementChild;
            input.focus();
        } else {
            logInfo('Focus method not support');
        }
    };

    return (
        <>
            <Row indent="24px">
                <NewInputWrapper
                    isReadOnly={field.isReadOnly}
                    comment={field.comment}
                    commentLong={field.commentLong}
                    name={field.name}
                    isFilled={isFilled}
                    isFocused={isFocused}
                    isDetached={false}
                    isError={field.isError}
                    labelText={field.placeholder}
                    errorMessage={field.errorMessage ? field.errorMessage : jsMessages[REQ_ERROR]}
                    setFocus={focus}
                    isPseudoSelect={false}
                    isEmptyValue={isEmptyValue}
                    isCaptcha={true}
                    leftInputComponent={
                        <CaptchaContainer data-testid="captcha-container">
                            <img height="56" width="240" src={captchaUrl} alt=" " />
                        </CaptchaContainer>
                    }
                >
                    <input
                        id={field.name}
                        name={field.canonicalPath ? field.canonicalPath : field.name}
                        value={field.value || ''}
                        type={field.type}
                        autoComplete="off"
                        onFocus={handlerFocus}
                        onChange={handlerChange}
                        onBlur={handlerBlur}
                    />
                </NewInputWrapper>
            </Row>
            <Row flex justify="center">
                <Button
                    type="button"
                    variant="secondary"
                    caption={restorePassChangeCaptcha}
                    id="tryAnother"
                    onClick={(e) => {
                        e.preventDefault();
                        setCaptchaUrl(getCaptchaURL());
                    }}
                />
            </Row>
        </>
    );
};
export default connect(null, { changeFormField })(InputCaptcha);
